export function localApiHosts(devPortBase) {
  const base = devPortBase ? Number(devPortBase) : null;
  return {
    backendHost: `http://localhost:${base === null ? 8080 : base + 1}`,
    apiV2Host: `http://localhost:${base === null ? 8081 : base + 2}`,
    editorHost: `http://localhost:${base === null ? 9080 : base + 3}`,
  };
}
